import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditProjectAllocatedResourcesBudgetRequest(
  state: State,
  { project }: Boundaries["editProjectAllocatedResourcesBudget"]["request"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToPending() }];
}

function handleEditProjectAllocatedResourcesBudgetSuccess(
  state: State,
  { project }: Boundaries["editProjectAllocatedResourcesBudget"]["success"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToSuccess() }];
}

function handleEditProjectAllocatedResourcesBudgetFailure(
  state: State,
  { project }: Boundaries["editProjectAllocatedResourcesBudget"]["failure"],
): State {
  const index = state.findIndex((req) => req.project.uuid === project.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { project, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { project, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectAllocatedResourcesBudgetRequested]:
      handleEditProjectAllocatedResourcesBudgetRequest,
    [events.editProjectAllocatedResourcesBudgetSucceeded]:
      handleEditProjectAllocatedResourcesBudgetSuccess,
    [events.editProjectAllocatedResourcesBudgetFailed]:
      handleEditProjectAllocatedResourcesBudgetFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
